import React, { useState, useEffect, useRef } from 'react';
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios';
import swal from 'sweetalert';
import 'react-dropzone-uploader/dist/styles.css'
import Select, { components } from 'react-select';
import moment from 'moment';

import { Modal } from 'react-bootstrap';

import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import { useTheme } from "./theme-provider.js";
import formatNumber from '../common_component/formatNumber.js';

function Banking() {
    const { theme, dropdownStyleDark } = useTheme()
    const [state, setState] = useState(2);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)

    const [addAccHeadModalShow, setAddAccHeadModalShow] = useState(false)
    const [editAccHeadModalShow, setEditAccHeadModalShow] = useState(false)
    const [defaultModalShow, setDefaultModalShow] = useState(false);

    const [open, setOpen] = useState(false);
    const [StatusModalShow, setStatusModalShow] = useState(false);

    const [Migration_date, setMigration_date] = useState(moment().format("yyyy-MM-DD"));
    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [branchList, setBranchlist] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [baseCurrency, setBaseCurrency] = useState(null);

    const [newHead, setNewHead] = useState({
        account_type: "bank", account_name: "", account_code: "", currency: "", branch: [], ifsc: "", bank_name: "", account_number: "", description: "", enable_upi: false,
        upi_id: "",
        upi_qr_code: ""
    })
    const [categoryList, setCategoryList] = useState([])
    const [bankList, setbankList] = useState([])
    const [Credit_amt, setCredit_amt] = useState(0);
    const [Category_id, setCategory_id] = useState("");
    const [Account_id, setAccount_id] = useState("");
    const [Debit_amt, setDebit_amt] = useState(0);
    const [Description, setDescription] = useState("");

    const [submitButton, SetSubmitButton] = useState(false)

    var page_name = "banking";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    async function getBankList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-bank-list`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "flag": true, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        //console.log(body.data)

        if (body.operation === "success") {
            setbankList(body.data);
        }
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    let timezone_change = body.data[0].timezone_value;
                    set_timezone_change(timezone_change);
                    setMigration_date(moment().zone(timezone_change).format('YYYY-MM-DD'));
                }
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setBranchlist(body.data);
        }
        else {
            throw "branch list api error"
        }
    }
    async function getcurrencydetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/currency-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.length != 0) {
            const default_currency = body.data.find(x => x.default_currency === 1);
            setCurrencyList(body.data);
            setBaseCurrency({ currency_id: default_currency.currency_id, currency_code: default_currency.currency_code, currency_symbol: default_currency.currency_symbol, format: default_currency.format, decimal_place: default_currency.decimal_place })
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getBankList();
            let p2 = getBranchDetails();
            let p3 = getcurrencydetails();
            let p4 = getTimezoneInformation();
            Promise.all([p1, p2, p3, p4])
                .then(() => {
                    setState(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setState(0)
                })
        }

    }, [user, visibility, read, write])

    const onClose = () => {
        setOpen(false);
    }

    const newHeadSubmit = async () => {
        var nexp = /^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 \/\\&|@#()\\[\]_.,:"']*)?$/;
        const accountNumberRegex = /^[0-9]{9,18}$/;
        const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
        //Name check
        if (newHead.account_name.trim() == "") {
            swal("Warning!", "Account name can't be blank.", "warning");
            return
        }
        if (!newHead.account_name.match(nexp)) {
            swal("Warning!", "Account name cannot contain a number or symbols", "warning");
            return
        }
        if (newHead.currency == "") {
            swal("Warning!", "Currency field can't be blank.", "warning");
            return
        }
        if (newHead.account_type === "bank") {
            if (newHead.account_number.trim() == "") {
                swal("Warning!", "Account number field can't be blank.", "warning");
                return
            }
            if (!accountNumberRegex.test(newHead.account_number.trim())) {
                swal("Warning!", "Invalid Account number format.", "warning");
                return
            }
        }

        if (newHead.bank_name.trim() == "") {
            swal("Warning!", "Bank name can't be blank.", "warning");
            return
        }
        if (newHead.account_type === "bank") {
            if (newHead.ifsc.trim() == "") {
                swal("Warning!", "IFSC field can't be blank.", "warning");
                return
            }
            if (!ifscRegex.test(newHead.ifsc.trim())) {
                swal("Warning!", "Invalid IFSC format.", "warning");
                return
            }
        }
        let amount = 0;
        if (Credit_amt != 0) {
            amount = -Credit_amt;
        }
        else if (Debit_amt != 0) {
            amount = Debit_amt;
        }
        let arr = newHead;
        // if (arr.branch !== undefined && arr.branch.length > 0) {
        //     //arr.branch = arr.branch.map(o => o.value)
        // }
        const formData = new FormData();

        // Basic fields
        formData.append("account_type", newHead.account_type);
        formData.append("account_name", newHead.account_name);
        formData.append("account_code", newHead.account_code);
        formData.append("currency", newHead.currency);
        formData.append("bank_name", newHead.bank_name);
        formData.append("account_number", newHead.account_number);
        formData.append("ifsc", newHead.ifsc);
        formData.append("description", newHead.description);
        formData.append("enable_upi", newHead.enable_upi);

        // Arrays
        if (newHead.branch && newHead.branch.length > 0) {
            newHead.branch.forEach((b) => {
                formData.append("branch[]", b);
            });
        }

        // UPI fields
        if (newHead.enable_upi) {
            formData.append("upi_id", newHead.upi_id);

            if (newHead.upi_qr_code) {
                formData.append("upi_qr", newHead.upi_qr_code); // FILE
            }
        }

        // Extra fields
        formData.append("page_name", page_name);
        formData.append("organization_id", organization_id);
        formData.append("Category_id", Category_id);
        formData.append("Account_id", Account_id);
        formData.append("Credit_amt", Credit_amt);
        formData.append("Debit_amt", Debit_amt);

        setState(2);
        SetSubmitButton(true);

        const api =
            Category_id !== "" && Account_id !== ""
                ? "update-bank-details"
                : "save-bank-details";

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/${api}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        token: getCookie("access_token"),
                    },
                }
            );

            SetSubmitButton(false);

            if (res.data.operation === "success") {
                swal("Great!", "Bank details saved successfully", "success").then(() => {
                    if (Category_id !== "" && Account_id !== "") {
                        setEditAccHeadModalShow(false);
                    }
                    else {
                        setAddAccHeadModalShow(false);
                    }
                    getBankList();
                    setState(1);
                });
            } else {
                swal("Oops!", res.data.message, "error");
            }
        } catch (err) {
            SetSubmitButton(false);
            console.error(err);
            swal("Error", "Something went wrong", "error");
        }
    }

    const EditBankDetails = (obj) => {
        setCategory_id(obj.bank_details.acc_cid);
        setAccount_id(obj.bank_details.acc_hid);
        setNewHead({
            account_type: obj.bank_details.account_type, account_name: obj.bank_details.account_name, account_code: obj.bank_details.account_code, currency: obj.bank_details.currency, branch: obj.bank_details.branch, ifsc: obj.bank_details.ifsc, bank_name: obj.bank_details.bank_name, account_number: obj.bank_details.account_number, description: obj.bank_details.description, enable_upi: obj.bank_details.upi_details?.enabled || false,
            upi_id: obj.bank_details.upi_details?.upi_id || "", upi_qr_code: obj.bank_details.upi_details?.upi_qr_code || ""
        });
        setEditAccHeadModalShow(true);
    }

    const closeBankModal = () => {
        setCategory_id("");
        setAccount_id("");
        setEditAccHeadModalShow(false);
    }

    const EditOpeningBalance = (obj) => {
        setCategory_id(obj.bank_details.acc_cid);
        setAccount_id(obj.bank_details.acc_hid);
        if (obj.headArray.length > 0) {
            setDescription(obj.headArray[0].description);
            setCredit_amt(obj.headArray[0].withdrawl_amnt);
            setDebit_amt(obj.headArray[0].deposit_amnt);

            if (obj.headArray[0].migration_date != undefined) {
                setMigration_date(moment(obj.headArray[0].migration_date).zone(timezone_change).format('YYYY-MM-DD'));
            }
            else {
                setMigration_date(moment().zone(timezone_change).format('YYYY-MM-DD'));
            }
        }
        setStatusModalShow(true);
    }

    const RecordOpeningBalance = () => {
        let amount = 0;
        if (Credit_amt != 0) {
            amount = -Credit_amt;
        }
        else if (Debit_amt != 0) {
            amount = Debit_amt;
        }
        let data = [{ Credit_amt: Credit_amt, Debit_amt: Debit_amt, amount: amount, hid: Account_id, cid: Category_id, "Description": Description, "date": Migration_date }]
        let object = { data: data, page_name: page_name, organization_id: organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        setMainSubmitButtonState(true)
        axios.post(`${process.env.REACT_APP_SERVER_URL}/record-bank-opening-balance`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", 'The bank amount has been recorded successfully.', "success").then((value) => {
                    window.location.reload();
                    getBankList()
                    setStatusModalShow(false)
                });
            }
            else {
                swal("Oops!", res.data.message.substring(0, 30), "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Banking Overview
                        <small className="text-muted fs-7 fw-bold my-1 ms-1"></small>
                    </h1>
                    <button className='btn btn-success'
                        onClick={(e) => {
                            setNewHead({
                                account_type: "bank", account_name: "", account_code: "", currency: "", branch: [], ifsc: "", bank_name: "", account_number: "", description: "", enable_upi: false,
                                upi_id: "",
                                upi_qr_code: ""
                            });
                            setAddAccHeadModalShow(true);
                        }}>
                        <i className="las la-plus"></i>
                        Add Bank
                    </button>
                </div>
                <div>
                    {
                        state == 1 ?
                            <div className="row g-6 g-xl-9">
                                {bankList.length > 0 ?
                                    <>
                                        {bankList.map((obj, index) => {
                                            return (
                                                <>
                                                    <div className="col-lg-6">
                                                        <div className="card card-flush h-lg-100">
                                                            <div className="card-header mt-6">
                                                                <div className="card-title flex-column">
                                                                    <h3 className="fw-bolder mb-1">{obj.bank_details.account_name}</h3>
                                                                    {obj.bank_details.log_status == "Active" ? <span className="badge badge-light-success me-auto rounded">Active</span> : (obj.bank_details.log_status == "Stopped" ? <span className="badge badge-light-danger me-auto rounded">Stopped</span> : <span className="badge badge-light-danger me-auto rounded">Deactivated</span>)}
                                                                </div>
                                                                <div className="card-toolbar">
                                                                    <div className="dropdown">
                                                                        {
                                                                            (write) ?
                                                                                <>
                                                                                    <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                        <i className="fas fa-bars px-0"></i>
                                                                                    </button>
                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                        <li><a onClick={(e) => { EditBankDetails(obj) }} className="dropdown-item cursor-pointer">Edit Details</a></li>
                                                                                        <li><a onClick={(e) => { EditOpeningBalance(obj); }} className="dropdown-item cursor-pointer">Opening Balance</a></li>
                                                                                        <li><a onClick={(e) => { EditBankDetails(obj); }} className="dropdown-item cursor-pointer">Set as default</a></li>
                                                                                    </ul>
                                                                                </>
                                                                                :
                                                                                null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-wrap">
                                                                <div className="card-body p-9">
                                                                    <div className="fs-6 d-flex justify-content-between mb-4">
                                                                        <div className="fw-bold">Account number</div>
                                                                        <div>
                                                                            {obj.bank_details.account_number}</div>
                                                                    </div>
                                                                    <div className="separator separator-dashed"></div>
                                                                    <div className="fs-6 d-flex justify-content-between my-4">
                                                                        <div className="fw-bold">Available Balance</div>
                                                                        <div>
                                                                            {baseCurrency.currency_symbol + formatNumber(obj.bank_details.available_balance, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</div>
                                                                    </div>
                                                                    <div className="separator separator-dashed"></div>
                                                                    <div className="fs-6 d-flex justify-content-between my-4">
                                                                        <div className="fw-bold">Bank Name</div>
                                                                        <div>
                                                                            {obj.bank_details.bank_name}</div>
                                                                    </div>
                                                                    {/* <div className="separator separator-dashed"></div>
                                                                    <div className="fs-6 d-flex justify-content-between my-4">
                                                                        <div className="fw-bold">Branch Name</div>
                                                                        <div>
                                                                            {obj.bank_details.bank_name}</div>
                                                                    </div> */}
                                                                    <div className="separator separator-dashed"></div>
                                                                    <div className="fs-6 d-flex justify-content-between mt-4">
                                                                        <div className="fw-bold">Add Date</div>

                                                                        <div>{moment(obj.bank_details.log_date_time).format('ll')}</div>
                                                                    </div><br />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            );
                                        })}
                                    </>
                                    :
                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                        <div className="d-flex flex-stack flex-grow-1">
                                            <div className="fw-bold">
                                                <h4 className="text-gray-800 fw-bolder">No Bank Available.</h4>
                                                <div className="fs-6 text-gray-600"> </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            :
                            state == 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                state == 3 ?
                                    <div className="flex-lg-row-fluid me-lg-15">
                                        <div className="card card-flush pt-3 mb-5 mb-lg-10">
                                            <div className="card-body pt-0">
                                                <div className="text-gray-500 fw-bold fs-5 mb-5"></div>
                                                <div className="d-flex align-items-center p-3 mb-2"></div>

                                                <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                    <div className="d-flex flex-stack flex-grow-1">
                                                        <div className="fw-bold">
                                                            <h4 className="text-gray-800 fw-bolder">No Banking Overview Available</h4>
                                                            <div className="fs-6 text-gray-600"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="flex-lg-row-fluid me-lg-15">
                                        <div className="card card-flush pt-3 mb-5 mb-lg-10">
                                            <div className="card-body pt-0">
                                                <div className="text-gray-500 fw-bold fs-5 mb-5"></div>
                                                <div className="d-flex align-items-center p-3 mb-2"></div>

                                                <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                    <div className="d-flex flex-stack flex-grow-1">
                                                        <div className="fw-bold">
                                                            <h4 className="text-gray-800 fw-bolder">Please Refresh this page</h4>
                                                            <div className="fs-6 text-gray-600"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                    }
                </div>
            </div>
            <Modal show={defaultModalShow} onHide={() => setDefaultModalShow(false)} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Set as Default</Modal.Title>
                    <div
                        className="btn btn-sm btn-icon btn-active-color-primary"
                        onClick={() => setDefaultModalShow(false)}
                    >
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                <g transform="translate(12,12) rotate(-45) translate(-12,-12) translate(4,4)" fill="#000000">
                                    <rect x="0" y="7" width="16" height="2" rx="1" />
                                    <rect opacity="0.5" transform="rotate(-270,8,8)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div className="text-center">
                        <div className="mb-4">
                            <i className="bi bi-check2-circle fs-1 text-primary"></i>
                        </div>
                        <h4 className="mb-2">Do you want to set this as your default configuration?</h4>
                    </div>
                </Modal.Body>

                <Modal.Footer className="justify-content-end">
                    <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => setDefaultModalShow(false)}
                    >
                        Close
                    </button>

                    {write && (
                        <button
                            type="button"
                            className="btn btn-success"
                            // onClick={(e) => SubmitQrSettings(operationType)}
                            data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
                            disabled={mainSubmitButtonState}
                        >
                            <span className="indicator-label">Set as Default</span>
                            <span className="indicator-progress">
                                Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
            <Modal show={editAccHeadModalShow} onHide={() => { closeBankModal(); }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Edit Bank Account</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { closeBankModal(); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-4 my-auto">
                                <label className="required fs-5 mb-2">Account Category</label>
                            </div>
                            <div className="col-4 me-2">
                                <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${newHead.account_type === "bank" && "active"}`} data-kt-button="true">
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                        <input className="form-check-input" type="radio" name="discount_option" onChange={(e) => {
                                            setNewHead({ account_type: "bank", account_name: "", account_code: "", currency: "", branch: [], ifsc: "", bank_name: "", Debit_amt: 0, Credit_amt: 0, account_number: "", description: "" })
                                        }} checked={newHead.account_type === "bank"} />
                                    </span>
                                    <span className="ms-5">
                                        <span className="fs-4 fw-bold text-gray-800 d-block">Bank</span>
                                    </span>
                                </label>
                            </div>
                            <div className="col-4">
                                <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${newHead.account_type === "credit_card" && "active"}`} data-kt-button="true">
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                        <input className="form-check-input" type="radio" name="discount_option" value="3" onChange={(e) => {
                                            setNewHead({ account_type: "credit_card", account_name: "", account_code: "", currency: "", bank_name: "", Debit_amt: 0, Credit_amt: 0, description: "" })
                                        }} checked={newHead.account_type === "credit_card"} />
                                    </span>
                                    <span className="ms-5">
                                        <span className="fs-4 fw-bold text-gray-800 d-block">Credit Card</span>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Account Name</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    value={newHead.account_name}
                                    onChange={(e) => { setNewHead({ ...newHead, account_name: e.target.value }) }}
                                    placeholder='Account Name'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Account Code</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    value={newHead.account_code}
                                    onChange={(e) => { setNewHead({ ...newHead, account_code: e.target.value }) }}
                                    placeholder='Account Code'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Currency</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <Select
                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                    options={currencyList.map(x => { return { label: x.currency_code, value: x.currency_id } })}
                                    onChange={(val) => { setNewHead({ ...newHead, currency: val.value }) }}
                                    value={(newHead.currency != "" && currencyList.length > 0) ? { label: currencyList.find(x => x.currency_id == newHead.currency).currency_code, value: newHead.currency } : null}
                                />
                            </div>
                        </div>
                        {newHead.account_type === "bank" &&
                            <div className="d-flex justify-content-between mb-5">
                                <div className="col-3 my-auto">
                                    <label className="required fs-5 mb-2">Account Number</label>
                                </div>
                                <div className='col-9 my-auto'>
                                    <input type="text" className="form-control form-control-solid"
                                        value={newHead.account_number}
                                        onChange={(e) => { setNewHead({ ...newHead, account_number: e.target.value }) }}
                                        placeholder='Account Number'
                                        readOnly
                                        disabled
                                    />
                                </div>
                            </div>}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Bank Name</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    value={newHead.bank_name}
                                    onChange={(e) => { setNewHead({ ...newHead, bank_name: e.target.value }) }}
                                    placeholder='Bank Name'
                                    readOnly
                                    disabled
                                />
                            </div>
                        </div>
                        {newHead.account_type === "bank" &&
                            <div className="d-flex justify-content-between mb-5">
                                <div className="col-3 my-auto">
                                    <label className="required fs-5 mb-2">IFSC</label>
                                </div>
                                <div className='col-9 my-auto'>
                                    <input type="text" className="form-control form-control-solid"
                                        value={newHead.ifsc}
                                        onChange={(e) => { setNewHead({ ...newHead, ifsc: e.target.value }) }}
                                        placeholder='IFSC Number'
                                        readOnly
                                        disabled
                                    />
                                </div>
                            </div>}
                        {newHead.account_type === "bank" &&
                            <div className="d-flex justify-content-between mb-5">
                                <div className="col-3 my-auto">
                                    <label className="fs-5 mb-2">Assosiate Branch</label>
                                </div>
                                <div className='col-9 my-auto'>
                                    <Select
                                        isMulti
                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                        options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                        onChange={(val) => {
                                            setNewHead({ ...newHead, branch: val.map((x) => { return x.value }) })
                                        }}
                                        value={(branchList.length > 0 && newHead.branch) ? newHead.branch.map(id => ({ value: `${id}`, label: branchList.find(detail => detail.branch_id === id)?.branch_name })) : []}
                                        placeholder="Select Branch"
                                    />
                                </div>
                            </div>}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Description</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <textarea type="text" className="form-control form-control-solid"
                                    value={newHead.account_name}
                                    onChange={(e) => { setNewHead({ ...newHead, description: e.target.value }) }}
                                    placeholder='Description'
                                />
                            </div>
                        </div>
                        {newHead.account_type === "bank" && (
                            <div className="mb-5">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <label className="fs-5 mb-0">UPI Details</label>
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={newHead.enable_upi}
                                            onChange={(e) =>
                                                setNewHead({
                                                    ...newHead,
                                                    enable_upi: e.target.checked,
                                                    upi_id: "",
                                                    upi_qr_code: ""
                                                })
                                            }
                                        />
                                        <label className="form-check-label text-muted">
                                            Enable UPI
                                        </label>
                                    </div>
                                </div>

                                {newHead.enable_upi && (
                                    <div className="border rounded-3 p-4 bg-white shadow-sm mt-3">

                                        {/* Header */}
                                        <div className="d-flex align-items-center mb-4">
                                            <i className="bi bi-qr-code fs-3 text-primary me-2"></i>
                                            <h5 className="mb-0">UPI Payment Details</h5>
                                        </div>

                                        {/* UPI ID */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold">
                                                UPI ID
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid"
                                                placeholder="example@upi"
                                                value={newHead.upi_id}
                                                onChange={(e) =>
                                                    setNewHead({ ...newHead, upi_id: e.target.value })
                                                }
                                            />
                                            <div className="form-text">
                                                Eg: name@bank
                                            </div>
                                        </div>

                                        {/* QR Upload + Preview */}
                                        <div className="row align-items-center">
                                            <div className="col-md-7">
                                                <label className="form-label fw-semibold">
                                                    UPI QR Code
                                                </label>

                                                <div className="border border-dashed rounded-3 p-4 text-center bg-light">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="d-none"
                                                        id="upiQrUpload"
                                                        onChange={(e) =>
                                                            setNewHead({
                                                                ...newHead,
                                                                upi_qr_code: e.target.files[0]
                                                            })
                                                        }
                                                    />

                                                    <label htmlFor="upiQrUpload" style={{ cursor: "pointer" }}>
                                                        <i className="bi bi-cloud-arrow-up fs-2 text-muted"></i>
                                                        <div className="fw-semibold mt-2">
                                                            Click to upload QR image
                                                        </div>
                                                        <div className="text-muted fs-7">
                                                            PNG or JPG only
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>

                                            {/* QR Preview */}
                                            <div className="col-md-5 text-center">
                                                {newHead.upi_qr_code ? (
                                                    <>
                                                        <div className="fw-semibold mb-2">Preview</div>
                                                        <img
                                                            src={
                                                                newHead.upi_qr_code instanceof File
                                                                    ? URL.createObjectURL(newHead.upi_qr_code)
                                                                    : newHead.upi_qr_code
                                                            }
                                                            alt="UPI QR"
                                                            className="border rounded-3 p-2"
                                                            style={{ width: 140 }}
                                                        />
                                                    </>
                                                ) : (
                                                    <div className="text-muted mt-4">
                                                        QR preview will appear here
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded me-auto" onClick={() => { closeBankModal(); }}>Close</button>
                    {
                        // write &&
                        <button className="btn btn-success rounded" data-kt-indicator={submitButton ? "on" : "off"} disabled={submitButton} onClick={() => { newHeadSubmit() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>
            <Modal show={addAccHeadModalShow} onHide={() => { setAddAccHeadModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>New Bank Account</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAddAccHeadModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-4 my-auto">
                                <label className="required fs-5 mb-2">Account Category</label>
                            </div>
                            {/* <div className='col-9 my-auto'> */}
                            {/* <div className="col-9 row row-cols-1 row-cols-md-3 row-cols-lg-1 row-cols-xl-3 g-9"> */}
                            <div className="col-4 me-2">
                                <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${newHead.account_type === "bank" && "active"}`} data-kt-button="true">
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                        <input className="form-check-input" type="radio" name="discount_option" onChange={(e) => {
                                            setNewHead({ account_type: "bank", account_name: "", account_code: "", currency: "", branch: [], ifsc: "", bank_name: "", Debit_amt: 0, Credit_amt: 0, account_number: "", description: "" })
                                        }} checked={newHead.account_type === "bank"} />
                                    </span>
                                    <span className="ms-5">
                                        <span className="fs-4 fw-bold text-gray-800 d-block">Bank</span>
                                    </span>
                                </label>
                            </div>
                            <div className="col-4">
                                <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${newHead.account_type === "credit_card" && "active"}`} data-kt-button="true">
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                        <input className="form-check-input" type="radio" name="discount_option" value="3" onChange={(e) => {
                                            setNewHead({ account_type: "credit_card", account_name: "", account_code: "", currency: "", bank_name: "", Debit_amt: 0, Credit_amt: 0, description: "" })
                                        }} checked={newHead.account_type === "credit_card"} />
                                    </span>
                                    <span className="ms-5">
                                        <span className="fs-4 fw-bold text-gray-800 d-block">Credit Card</span>
                                    </span>
                                </label>
                            </div>
                        </div>
                        {/* </div> */}
                        {/* </div> */}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Account Name</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, account_name: e.target.value }) }}
                                    placeholder='Account Name'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Account Code</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, account_code: e.target.value }) }}
                                    placeholder='Account Code'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Currency</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <Select
                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                    options={currencyList.map(x => { return { label: x.currency_code, value: x.currency_id } })}
                                    onChange={(val) => { setNewHead({ ...newHead, currency: val.value }) }}
                                    value={(newHead.currency != "" && currencyList.length > 0) ? { label: currencyList.find(x => x.currency_id == newHead.currency).currency_code, value: newHead.currency } : null}
                                />
                            </div>
                        </div>
                        {newHead.account_type === "bank" &&
                            <div className="d-flex justify-content-between mb-5">
                                <div className="col-3 my-auto">
                                    <label className="required fs-5 mb-2">Account Number</label>
                                </div>
                                <div className='col-9 my-auto'>
                                    <input type="text" className="form-control form-control-solid"
                                        // value={primaryContact.firstName}
                                        onChange={(e) => { setNewHead({ ...newHead, account_number: e.target.value }) }}
                                        placeholder='Account Number'
                                    />
                                </div>
                            </div>}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Bank Name</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, bank_name: e.target.value }) }}
                                    placeholder='Bank Name'
                                />
                            </div>
                        </div>
                        {newHead.account_type === "bank" &&
                            <div className="d-flex justify-content-between mb-5">
                                <div className="col-3 my-auto">
                                    <label className="required fs-5 mb-2">IFSC</label>
                                </div>
                                <div className='col-9 my-auto'>
                                    <input type="text" className="form-control form-control-solid"
                                        // value={primaryContact.firstName}
                                        onChange={(e) => { setNewHead({ ...newHead, ifsc: e.target.value }) }}
                                        placeholder='IFSC Number'
                                    />
                                </div>
                            </div>}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Opening Balance</label>
                            </div>
                            <div className='col-4 me-3'>
                                <input type="number" className="form-control form-control-solid"
                                    value={Credit_amt.toString()}
                                    onChange={(e) => { setCredit_amt(e.target.value == "" ? 0 : parseFloat(e.target.value)) }}
                                    onBlur={(e) => { setDebit_amt(0) }}
                                    placeholder='Credit'
                                />
                                <span className="text-muted fs-6">Credit Amount</span>
                            </div>
                            {/* <div className='col-2 my-auto'></div> */}
                            <div className='col-4'>
                                <input type="number" className="form-control form-control-solid"
                                    value={Debit_amt.toString()}
                                    onChange={(e) => { setDebit_amt(e.target.value == "" ? 0 : parseFloat(e.target.value)) }}
                                    onBlur={(e) => { setCredit_amt(0) }}
                                    placeholder='Debit'
                                />
                                <span className="text-muted fs-6">Debit Amount</span>
                            </div>
                        </div>
                        {newHead.account_type === "bank" &&
                            <div className="d-flex justify-content-between mb-5">
                                <div className="col-3 my-auto">
                                    <label className="fs-5 mb-2">Assosiate Branch</label>
                                </div>
                                <div className='col-9 my-auto'>
                                    <Select
                                        isMulti
                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                        options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                        onChange={(val) => {
                                            setNewHead({ ...newHead, branch: val.map((x) => { return x.value }) })
                                        }}
                                        value={(branchList.length > 0 && newHead.branch) ? newHead.branch.map(id => ({ value: `${id}`, label: branchList.find(detail => detail.branch_id === id)?.branch_name })) : []}
                                        placeholder="Select Branch"
                                    />
                                </div>
                            </div>}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Description</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <textarea type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, description: e.target.value }) }}
                                    placeholder='Description'
                                />
                            </div>
                        </div>
                        {newHead.account_type === "bank" && (
                            <div className="mb-5">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <label className="fs-5 mb-0">UPI Details</label>
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={newHead.enable_upi}
                                            onChange={(e) =>
                                                setNewHead({
                                                    ...newHead,
                                                    enable_upi: e.target.checked,
                                                    upi_id: "",
                                                    upi_qr_code: ""
                                                })
                                            }
                                        />
                                        <label className="form-check-label text-muted">
                                            Enable UPI
                                        </label>
                                    </div>
                                </div>

                                {newHead.enable_upi && (
                                    <div className="border rounded-3 p-4 bg-white shadow-sm mt-3">

                                        {/* Header */}
                                        <div className="d-flex align-items-center mb-4">
                                            <i className="bi bi-qr-code fs-3 text-primary me-2"></i>
                                            <h5 className="mb-0">UPI Payment Details</h5>
                                        </div>

                                        {/* UPI ID */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold">
                                                UPI ID
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid"
                                                placeholder="example@upi"
                                                value={newHead.upi_id}
                                                onChange={(e) =>
                                                    setNewHead({ ...newHead, upi_id: e.target.value })
                                                }
                                            />
                                            <div className="form-text">
                                                Eg: name@bank
                                            </div>
                                        </div>

                                        {/* QR Upload + Preview */}
                                        <div className="row align-items-center">
                                            <div className="col-md-7">
                                                <label className="form-label fw-semibold">
                                                    UPI QR Code
                                                </label>

                                                <div className="border border-dashed rounded-3 p-4 text-center bg-light">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="d-none"
                                                        id="upiQrUpload"
                                                        onChange={(e) =>
                                                            setNewHead({
                                                                ...newHead,
                                                                upi_qr_code: e.target.files[0]
                                                            })
                                                        }
                                                    />

                                                    <label htmlFor="upiQrUpload" style={{ cursor: "pointer" }}>
                                                        <i className="bi bi-cloud-arrow-up fs-2 text-muted"></i>
                                                        <div className="fw-semibold mt-2">
                                                            Click to upload QR image
                                                        </div>
                                                        <div className="text-muted fs-7">
                                                            PNG or JPG only
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>

                                            {/* QR Preview */}
                                            <div className="col-md-5 text-center">
                                                {newHead.upi_qr_code ? (
                                                    <>
                                                        <div className="fw-semibold mb-2">Preview</div>
                                                        <img
                                                            src={
                                                                newHead.upi_qr_code instanceof File
                                                                    ? URL.createObjectURL(newHead.upi_qr_code)
                                                                    : newHead.upi_qr_code
                                                            }
                                                            alt="UPI QR"
                                                            className="border rounded-3 p-2"
                                                            style={{ width: 140 }}
                                                        />
                                                    </>
                                                ) : (
                                                    <div className="text-muted mt-4">
                                                        QR preview will appear here
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        )}

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded me-auto" onClick={() => { setAddAccHeadModalShow(false) }}>Close</button>
                    {
                        // write &&
                        <button className="btn btn-success rounded" data-kt-indicator={submitButton ? "on" : "off"} disabled={submitButton} onClick={() => { newHeadSubmit() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={StatusModalShow} onHide={() => { setStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Record Opening Balance</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Date:</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="date" name="Migration_date" className="form-control" id="Migration_date" placeholder="Sales Start Date" value={Migration_date}
                                    onChange={(e) => {
                                        setMigration_date(moment(e.target.value).zone(timezone_change).format('YYYY-MM-DD'));
                                        const temp = [...categoryList];
                                        temp.map((obj) => {
                                            obj.headArray.map((obj1) => {
                                                obj1.Date = moment(e.target.value).zone(timezone_change).format('YYYY-MM-DD');
                                            })
                                        })
                                        setCategoryList(temp);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Opening Balance</label>
                            </div>
                            <div className='col-4 me-3'>
                                <input type="number" className="form-control form-control-solid"
                                    value={Credit_amt.toString()}
                                    onChange={(e) => { setCredit_amt(e.target.value == "" ? 0 : parseFloat(e.target.value)) }}
                                    onBlur={(e) => { setDebit_amt(0) }}
                                    placeholder='Credit'
                                />
                                <span className="text-muted fs-6">Credit Amount</span>
                            </div>
                            {/* <div className='col-2 my-auto'></div> */}
                            <div className='col-4'>
                                <input type="number" className="form-control form-control-solid"
                                    value={Debit_amt.toString()}
                                    onChange={(e) => { setDebit_amt(e.target.value == "" ? 0 : parseFloat(e.target.value)) }}
                                    onBlur={(e) => { setCredit_amt(0) }}
                                    placeholder='Debit'
                                />
                                <span className="text-muted fs-6">Debit Amount</span>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Description</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <textarea type="text" className="form-control form-control-solid"
                                    value={Description}
                                    onChange={(e) => { setDescription(e.target.value) }}
                                    placeholder='Description'
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setStatusModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { RecordOpeningBalance(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Record</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default Banking;